import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom";
import SupportModal from "../Modal/SupportModal";
import AssessmentModal from "../Modal/AssessmentModal";
import React from "react";
import LoginModal from "../Modal/LoginModal";

const HeadsetIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="currentColor"
    viewBox="0 0 16 16"
    style={{ verticalAlign: "middle" }}
    aria-label="Support"
  >
    <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z" />
  </svg>
);

function Header() {
  const location = useLocation();
  const [modalShow, setModalShow] = React.useState(false);
  const [loginModalShhow, setloginModalShhow] = React.useState(false);
  const [assessmentModalShow, setAssessmentModalShow] = React.useState(false);

  const activeClass = (path) => `nav-link${location.pathname === path ? ' nav-active' : ''}`;
  const academyClass = `nav-link${location.pathname === '/academy' ? ' custom-button' : ''}`;

  return (
    <>
      <SupportModal show={modalShow} onHide={() => setModalShow(false)} />
      <LoginModal show={loginModalShhow} onHide={() => setloginModalShhow(false)} />
      <AssessmentModal show={assessmentModalShow} onHide={() => setAssessmentModalShow(false)} />

      {/* ── Desktop ─────────────────────────────────────── */}
      <Navbar className="custom-nav destkop-header" collapseOnSelect expand="lg" bg="" variant="dark">
        <Container>
          <Navbar.Brand className="d-none">placeholder</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">

            <Nav style={{ flex: 1 }}>
              <Link to="/about-us" className={activeClass('/about-us')}>About Us</Link>
              <Link to="/programs" className={activeClass('/programs')}>Programs</Link>
            </Nav>

            {/* Logo — margin:0 overrides Bootstrap's default margin-right:1rem for true centering */}
            <Navbar.Brand style={{ margin: 0 }}>
              <Link to="/">
                <img src="assets/images/cancer-silver.png" width="250" height="80" alt="" />
              </Link>
            </Navbar.Brand>

            <Nav style={{ flex: 1, justifyContent: 'flex-end' }}>
              <Link to="/insurance" className={activeClass('/insurance')}>Insurance</Link>
              <Link to="/hospital" className={activeClass('/hospital')}>Hospitals</Link>
              <Link
                to=""
                className="nav-link nav-icon-link"
                title="Support"
                onClick={(e) => { e.preventDefault(); setModalShow(true); }}
              >
                <HeadsetIcon />
              </Link>
              <Link
                to=""
                className={academyClass}
                onClick={(e) => { e.preventDefault(); setloginModalShhow(true); }}
              >
                Academy
              </Link>
            </Nav>

          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* ── Mobile ──────────────────────────────────────── */}
      <Navbar className="custom-nav mobile-header" collapseOnSelect expand="lg" bg="" variant="dark">
        <Container>
          <Navbar.Brand>
            <Link to="/">
              <img src="assets/images/cancer-silver.png" style={{ maxWidth: "200px" }} alt="" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Link to="/about-us" className={activeClass('/about-us')}>About Us</Link>
              <Link to="/programs" className={activeClass('/programs')}>Programs</Link>
              <Link to="/insurance" className={activeClass('/insurance')}>Insurance</Link>
              <Link to="/hospital" className={activeClass('/hospital')}>Hospitals</Link>
              <Link to="" className="nav-link" onClick={(e) => { e.preventDefault(); setModalShow(true); }}>Support</Link>
              <Link to="" className={academyClass} onClick={(e) => { e.preventDefault(); setloginModalShhow(true); }}>Academy</Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
